export default {
  // 银行主数据列表
  GET_BANK_LIST: '/maindata/bank/search',
  // 修改银行主数据状态
  UPDATE_BANK_STATUS: '/maindata/bank/updateStatus',
  // 导入银行主数据
  IMPORT_BANK: '/maindata/bank/import',
};
